module.exports = __webpack_public_path__ + "img/voucher-expired.c91bae2b.svg";